import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNormalizeSpaces]'
})
export class NormalizeSpacesDirective {

  constructor(
    private el: ElementRef,
    @Optional() @Self() private control: NgControl
  ) {}

  @HostListener('blur', [
    '$event.target',
    '$event.target.value',
  ])
  onBlur() {
    const rawValue = this.el.nativeElement.value;

    if (typeof rawValue === 'string') {
      // Очистка: один пробел между словами, убрать пробелы в начале/конце
      const cleaned = rawValue.trim().replace(/\s+/g, ' ');

      // Обновление DOM-элемента
      this.el.nativeElement.value = cleaned;

      // Обновление значения FormControl
      if (this.control?.control) {
        this.control.control.setValue(cleaned, { emitEvent: true });
      }
    }
  }
}
